export default __webpack_public_path__ + "static/media/portfolio.aa0c5a6f.less";